/** Formulaire public : barre d'actions dans le flux sans filet (formulaire court, le bouton suit les champs). */
export const PUBLIC_FORM =
  'space-y-5 [&_[data-form-actions=flow]]:mt-7 [&_[data-form-actions=flow]]:border-0 [&_[data-form-actions=flow]]:pt-0';

/** Lien d'action discret (retour, « Mot de passe oublié ? ») : cible de 44 px, souligné, focus visible. */
export const quietLinkClasses =
  'inline-flex min-h-11 items-center rounded-lg text-[0.9375rem] font-medium text-ink-2 underline decoration-line-strong underline-offset-4 transition-colors hover:text-ink hover:decoration-ink-3 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus';

/** Lien dans un message (`Alert`) : cible de 44 px, souligné. */
export const alertLinkClasses = 'inline-flex min-h-11 items-center font-semibold underline underline-offset-4';
